export default __webpack_public_path__ + "static/media/notting_2.7ba8ec2e.jpg";